<template>
  <div class="page-ias_book">
    <div style="height: 100%">
      <div style="height: calc(100vh - 56px)">
        <div class="breadcrumb">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="margin-bottom: 20px"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>版本信息</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <el-container class="version-main">
          <el-aside width="260px" style="background-color: #fff">
            <el-menu
              class="el-menu-vertical-demo"
              v-if="versionList"
              :default-active="activeIndex"
              style="height: 95%; overflow-y: auto"
              @select="handleSelect"
            >
              <el-menu-item
                v-for="(item, index) in versionList"
                :index="`${index}`"
                :key="item.version"
              >
                <span slot="title" class="title">
                  <em>版本号：{{ item.version }}</em>
                  <em> {{ item.date }}</em>
                </span>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-container>
            <div class="content">
              <div class="content-warp" v-if="versionDetail">
                <h1>MIS营销情报系统{{ versionDetail.version }}版本更新</h1>
                <h4>上线日期: {{ versionDetail.date }}</h4>
                <div>
                  <div class="desc" v-html="versionDetail.desc"></div>
                  <h3 v-if="versionDetail.newDetail">【功能新增】</h3>
                  <ul
                    v-for="(item, index) in versionDetail.newDetail"
                    :key="index"
                  >
                    <li>{{ index + 1 }}、{{ item }}</li>
                  </ul>
                  <h3 v-if="versionDetail.fixDetail">【功能优化】</h3>
                  <ul
                    v-for="(item, index) in versionDetail.fixDetail"
                    :key="index"
                  >
                    <li>{{ index + 1 }}、{{ item }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </el-container>
        </el-container>
      </div>
    </div>
  </div>
</template>
<script>
import { versionTest } from "@/pages/views/version/version";

export default {
  data() {
    return {
      versionList: {},
      versionDetail: {},
      activeIndex: 0
    };
  },
  activated() {},
  watch: {},
  mounted() {
    this.handleSelect();
    this.versionList = versionTest;
    // console.log(window.SERVERAPI.API_SMART);
    // if (window.SERVERAPI.API_SMART === "https://aicpapi.hzfanews.com") {
    //   this.versionList = versionPrd;
    // } else {
    //   this.versionList = versionTest;
    // }
  },
  created() {},
  methods: {
    handleSelect(keys = 0) {
      this.versionDetail = null;
      setTimeout(() => {
        this.versionDetail = this.versionList[keys];
      }, 100);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-ias_book {
  background: var(--bg);
  height: 100%;
  overflow: hidden;
}
.breadcrumb {
  padding: 15px 20px 0;
  > div {
    margin-bottom: 15px !important;
  }
}
.version-main {
  height: calc(100vh - 105px);
  overflow: hidden;
  margin: 0 20px;
  background: #fff;
  // box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border: 1px var(--border-color) solid;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  em {
    font-style: normal;
  }
}
.content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  .content-warp {
    width: 60%;
    margin: 0 auto;
    h1 {
      width: 100%;
      text-align: center;
      font-size: 32px;
      padding-top: 20px;
    }
    h3 {
      width: 100%;
      text-align: left;
      color: var(--text-1);
      padding: 20px 0 15px;
      font-size: 16px;
    }
    h4 {
      width: 100%;
      text-align: center;
      color: var(--text-3);
      border-bottom: 1px solid var(--border-3);
      padding: 15px 0;
      font-size: 14px;
      font-weight: normal;
    }
    ul {
      font-weight: normal;
      color: var(--text-2);
      margin-left: 26px;
      li {
        margin-bottom: 10px;
        font-size: 14px;
      }
    }
  }
}
::v-deep .desc {
  font-size: 15px;
  color: var(--text-1);
  p {
    margin-bottom: 15px;
  }
}
</style>
